import { X, Send } from "lucide-react";
import FilePreview from "./FilePreview";

const FileList = ({ files, setFiles }) => {
  const removeFile = (id) => {
    setFiles((prev) => prev.filter((f) => f.id !== id));
  };
  
  const handleSend = () => {
    // Handle sending files
    console.log("Sending files:", files);
    setFiles([]);
    // setShowPreview(false);
  };
  return (
    <div className="mt-2 bg-gray-50 rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      <div className="bg-gray-100 px-3 py-2 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-700">
            {files.length} file{files.length > 1 ? "s" : ""} selected
          </span>
          <button
            onClick={() => {
              setFiles([]);
            }}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 p-3">
        {files.map((fileObj) => (
          <FilePreview fileObj={fileObj} key={fileObj.id} />
        ))}
      </div>

      {/* Send Button */}
      <div className="bg-gray-50 px-3 py-2 border-t border-gray-200">
        <button
          onClick={handleSend}
          disabled={!files.every((f) => f.uploaded)}
          className={`w-full flex items-center justify-center space-x-2 py-2 px-4 rounded-md font-medium text-sm transition-all ${
            files.every((f) => f.uploaded)
              ? "bg-blue-500 hover:bg-blue-600 text-white"
              : "bg-gray-200 text-gray-400 cursor-not-allowed"
          }`}
        >
          <Send className="w-4 h-4" />
          <span>
            Send {files.length} file{files.length > 1 ? "s" : ""}
          </span>
        </button>
      </div>
    </div>
  );
};

export default FileList;
